export { default } from "./ChevronRightIcon";
